"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4401],{

/***/ 1191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ LinkAction; },
/* harmony export */   "a": function() { return /* binding */ Action; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(72986);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_text_node__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12284);
/* harmony import */ var _lib_captureEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75507);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8016);
/* harmony import */ var _lib_trackTTQEvent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52970);
/* harmony import */ var _state_containers_experiment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30784);














function checkIsExternal(string) {
    return /(http(s?)):\/\//i.test(string);
}
var LinkAction = function(_param) {
    var children = _param.children, event = _param.event, href = _param.href, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "event",
        "href"
    ]);
    var handleClick = function() {
        (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_4__/* .captureEvent */ .e)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, event), {
            label: children
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            onClick: handleClick
        }, props), {
            children: children
        }))
    });
};
var Action = function(_param) {
    var at = _param.at, _defaultClasses = _param.defaultClasses, defaultClasses = _defaultClasses === void 0 ? "text-sm md:text-base rounded-full cta" : _defaultClasses, className = _param.className, event = _param.event, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "at",
        "defaultClasses",
        "className",
        "event"
    ]);
    var variant = (0,_state_containers_experiment__WEBPACK_IMPORTED_MODULE_7__/* .useExperiment */ .a)().variant;
    var accessedVariant = (0,_components_text_node__WEBPACK_IMPORTED_MODULE_3__/* .accessVariant */ .Rz)(at, variant);
    var sendEvent = function() {
        (0,_lib_trackTTQEvent__WEBPACK_IMPORTED_MODULE_6__/* .trackTTQEvent */ .q)("ClickButton");
        (0,_lib_captureEvent__WEBPACK_IMPORTED_MODULE_4__/* .captureEvent */ .e)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            category: at,
            action: "find_my_plan_cta_clicked",
            label: accessedVariant.label
        }, event));
    };
    var handleClick = function(e) {
        var ref;
        sendEvent();
        props === null || props === void 0 ? void 0 : (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props);
    };
    var href = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (accessedVariant.link) {
            return accessedVariant.link;
        }
        if (accessedVariant.href) {
            return (0,_lib_misc__WEBPACK_IMPORTED_MODULE_5__/* .updateUTMParams */ .m2)(accessedVariant.href).href;
        }
    }, [
        accessedVariant
    ]);
    if (false) {}
    return(// <Link href={href}>
    /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.a */ .E.a, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        key: href,
        href: href,
        target: accessedVariant.target ? accessedVariant.target : accessedVariant.href ? "_self" : "",
        rel: "noreferrer",
        onClick: handleClick,
        "aria-label": accessedVariant.label,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("relative inline-block cursor-pointer", defaultClasses, className),
        whileHover: {
            scale: 1.025
        },
        whileTap: {
            scale: 0.975
        }
    }), accessedVariant.label));
};


/***/ }),

/***/ 44401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; },
/* harmony export */   "Z": function() { return /* binding */ NavContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63153);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72986);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21190);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89211);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81341);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8016);
/* harmony import */ var _lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93335);
/* harmony import */ var _state_containers_app__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60208);
/* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1191);
/* harmony import */ var _text_node__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12284);














var Logo = function(param) {
    var _src = param.src, src = _src === void 0 ? "/assets/logo/white.svg" : _src;
    var isMobile = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_5__/* .useIsMobile */ .dD)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: "self-start",
        src: src,
        alt: "Ladder Logo",
        width: 632 * (isMobile ? 0.15 : 0.2),
        height: 104 * (isMobile ? 0.15 : 0.2)
    });
};
var Nav = function(param) {
    var toggleMobileMenuOpen = param.toggleMobileMenuOpen, mobileMenuOpen = param.mobileMenuOpen, _showAdditionalActions = param.showAdditionalActions, showAdditionalActions = _showAdditionalActions === void 0 ? true : _showAdditionalActions, showWWOD = param.showWWOD;
    var isHeroCTAInView = (0,_state_containers_app__WEBPACK_IMPORTED_MODULE_6__/* .useApp */ .q)().isHeroCTAInView;
    var isMobile = (0,_lib_use_breakpoint__WEBPACK_IMPORTED_MODULE_5__/* .useIsMobile */ .dD)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.nav */ .E.nav, {
        className: "sticky top-0 z-50 flex items-center justify-between w-full px-4 py-2 text-white bg-black lg:px-12 bg-opacity-60 backdrop-blur-xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Logo, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div, {
                initial: {
                    opacity: isMobile ? 1 : 0
                },
                animate: {
                    opacity: isMobile ? 1 : isHeroCTAInView ? 0 : 1
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)("flex items-center space-x-4 text-white"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "items-center hidden space-x-6 text-sm lg:flex",
                        children: [
                            showWWOD ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                                event: {
                                    action: "WWOD_page__clicked",
                                    category: "nav"
                                },
                                href: (0,_lib_misc__WEBPACK_IMPORTED_MODULE_4__/* .updateUTMParams */ .m2)("/workout/today"),
                                className: "uppercase hover:opacity-80",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        className: "text-volt",
                                        children: "Free"
                                    }),
                                    " Workout Of The Day"
                                ]
                            }) : null,
                            showAdditionalActions ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                                        event: {
                                            action: "ladder_shop_clicked",
                                            category: "nav"
                                        },
                                        href: "https://shop.joinladder.com/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "uppercase hover:opacity-80",
                                        children: "Shop"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                                        event: {
                                            action: "ladder_careers_clicked",
                                            category: "nav"
                                        },
                                        href: "https://ladder.breezy.hr",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "uppercase hover:opacity-80",
                                        children: "Careers"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: isHeroCTAInView ? 0 : 1
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .Action */ .a, {
                            at: "nav.cta",
                            className: "flex px-4 py-2 text-xs text-black rounded-full md:text-sm lg:px-6 cta bg-volt"
                        })
                    }),
                    showAdditionalActions ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "aria-label": mobileMenuOpen ? "close menu" : "open menu",
                        onClick: toggleMobileMenuOpen,
                        className: "flex lg:hidden",
                        children: mobileMenuOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* .XIcon */ .b0D, {
                            className: "w-6 h-6 text-white"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* .MenuIcon */ .Oqj, {
                            className: "w-6 h-6 text-white"
                        })
                    }) : null
                ]
            })
        ]
    });
};
var MobileMenu = function(param) {
    var toggleMobileMenuOpen = param.toggleMobileMenuOpen, mobileMenuOpen = param.mobileMenuOpen, _showAdditionalActions = param.showAdditionalActions, showAdditionalActions = _showAdditionalActions === void 0 ? true : _showAdditionalActions, showWWOD = param.showWWOD;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div, {
        initial: {
            opacity: 0,
            y: -25
        },
        animate: {
            opacity: 1,
            y: 0
        },
        className: "fixed inset-0 z-50 w-screen h-screen text-white bg-black bg-opacity-80 backdrop-blur-xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-4 py-3 text-xs text-center border-b border-gray-600",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_text_node__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                    as: "span",
                    at: "notice.home"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.nav */ .E.nav, {
                className: "flex items-center justify-between w-full px-4 py-2 text-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: 95
                        },
                        className: "flex justify-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Logo, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        "aria-label": mobileMenuOpen ? "close menu" : "open menu",
                        onClick: toggleMobileMenuOpen,
                        className: "flex lg:hidden",
                        children: mobileMenuOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* .XIcon */ .b0D, {
                            className: "w-6 h-6 text-white"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_1__/* .MenuIcon */ .Oqj, {
                            className: "w-6 h-6 text-white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-2 pt-12 mx-2 border-t border-gray-600",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col items-start space-y-6 text-xl text-left cta",
                    children: [
                        showWWOD ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                            event: {
                                action: "WWOD_page__clicked",
                                category: "nav"
                            },
                            href: (0,_lib_misc__WEBPACK_IMPORTED_MODULE_4__/* .updateUTMParams */ .m2)("/workout/today"),
                            className: "uppercase hover:opacity-80",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "Free"
                                }),
                                " Workout Of The Day"
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                            event: {
                                action: "pricing_page__clicked",
                                category: "nav"
                            },
                            className: "uppercase hover:opacity-80",
                            href: "/pricing",
                            children: "Pricing"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                            event: {
                                action: "ladder_shop_clicked",
                                category: "nav"
                            },
                            href: "https://shop.joinladder.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "uppercase hover:opacity-80",
                            children: "Shop"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .LinkAction */ .N, {
                            event: {
                                action: "ladder_careers_clicked",
                                category: "nav"
                            },
                            href: "https://ladder.breezy.hr",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "uppercase hover:opacity-80",
                            children: "Careers"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_action__WEBPACK_IMPORTED_MODULE_7__/* .Action */ .a, {
                            at: "nav.cta",
                            defaultClasses: "text-xl",
                            className: "text-left uppercase text-volt"
                        })
                    ]
                })
            })
        ]
    });
};
function NavContainer() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,react_use__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(false), 2), mobileMenuOpen = ref[0], toggleMobileMenuOpen = ref[1];
    (0,react_use__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(mobileMenuOpen);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Nav, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                mobileMenuOpen: mobileMenuOpen,
                toggleMobileMenuOpen: toggleMobileMenuOpen
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_15__/* .AnimatePresence */ .M, {
                children: mobileMenuOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileMenu, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                    mobileMenuOpen: mobileMenuOpen,
                    toggleMobileMenuOpen: toggleMobileMenuOpen
                }, props)) : null
            })
        ]
    });
};


/***/ }),

/***/ 12284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rz": function() { return /* binding */ accessVariant; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony export access */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _data_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67341);
/* harmony import */ var _state_containers_experiment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30784);






function access(o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    for(var i = 0, n = a.length; i < n; ++i){
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}
function accessVariant(at, variant) {
    var accessed = access(_data_json__WEBPACK_IMPORTED_MODULE_2__, at);
    if ("string" === typeof accessed) return accessed;
    return accessed[variant] || accessed[0] || accessed;
}
var Text = function(_param) {
    var at = _param.at, as = _param.as, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "at",
        "as"
    ]);
    var variant = (0,_state_containers_experiment__WEBPACK_IMPORTED_MODULE_3__/* .useExperiment */ .a)().variant;
    var accessedVariant = accessVariant(at, variant);
    if (!accessedVariant) {
        console.error("Text node at ".concat(at, " not found"));
        return null;
    }
    if (accessedVariant === null || accessedVariant === void 0 ? void 0 : accessedVariant.html) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        // as={as}
        dangerouslySetInnerHTML: {
            __html: accessedVariant === null || accessedVariant === void 0 ? void 0 : accessedVariant.html
        }
    }, props));
    return accessedVariant;
};


/***/ }),

/***/ 99986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LK": function() { return /* binding */ getTeams; },
/* harmony export */   "t7": function() { return /* binding */ useTeam; },
/* harmony export */   "y2": function() { return /* binding */ useTeams; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);
/* harmony import */ var _lib_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8016);






var getTeams = function() {
    var teamID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_lib_misc__WEBPACK_IMPORTED_MODULE_3__/* .fetcher */ ._i)("https://rocky-api.prod.ltdev.io" + "/bootcamps/" + teamID, {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};
var useTeams = function(teamID) {
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)("/teams", getTeams(), {
        refetchOnWindowFocus: false
    }), _data = ref.data, data = _data === void 0 ? [] : _data, error = ref.error, isLoading = ref.isLoading;
    var teams = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.filter) === null || ref === void 0 ? void 0 : ref.call(data, function(n) {
            return (n === null || n === void 0 ? void 0 : n.status) === "active";
        })) || [];
    }, [
        data
    ]);
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return teamID ? teams.filter(function(param) {
            var id = param.id;
            return teamID === id;
        }) : teams;
    }, [
        teamID,
        teams
    ]), 1), activeTeam = ref1[0];
    var getTeamById = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function(ID) {
        if (ID) {
            var ref;
            return (ref = teams.filter(function(param) {
                var id = param.id;
                return ID === id;
            })) === null || ref === void 0 ? void 0 : ref[0];
        }
    }, [
        teams
    ]);
    return {
        teams: teams,
        teamID: teamID,
        activeTeam: activeTeam,
        getTeamById: getTeamById,
        error: error,
        isLoading: isLoading
    };
};
var useTeam = function(teamID) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)("/team/".concat(teamID), getTeams(teamID), {
        refetchOnMount: false,
        refetchOnWindowFocus: false
    }), tmp = ref.data, team = tmp === void 0 ? {} : tmp, error = ref.error, isLoading = ref.isLoading;
    return {
        team: team,
        teamID: teamID,
        error: error,
        isLoading: isLoading
    };
};


/***/ }),

/***/ 75507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ captureEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40364);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52979);
/* harmony import */ var _gtag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61474);






var capturedEvents = {};
var updateCapturedEvents = function(action) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!action) return;
    capturedEvents[action] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, data), {
        timestamp: new Date()
    });
};
var eventIsDuplicated = function(action, data) {
    var ref;
    // add exception for Match_Quiz_CTA_Clicked.
    // because it's such a critical event, we don't care if it gets duplicated
    if (action === "Match_Quiz_CTA_Clicked") return false;
    if (!(data === null || data === void 0 ? void 0 : data.value)) return false;
    if (typeof (data === null || data === void 0 ? void 0 : data.value) !== "string") return false;
    if (!((ref = capturedEvents[action]) === null || ref === void 0 ? void 0 : ref.value)) return false;
    if (capturedEvents[action].value !== data.value) return false;
    if (!capturedEvents[action].timestamp) return false;
    // if the same event with the same value was sent within the last 10 seconds,
    // pevent the duplicate event from being sent
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(new Date(), capturedEvents[action].timestamp) < 10;
};
var captureEvent = function(_param) {
    var action = _param.action, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "action"
    ]);
    var ref;
    if (eventIsDuplicated(action, data)) {
        return console.log("preventing duplicate event call", capturedEvents[action]);
    }
    updateCapturedEvents(action, data);
    console.log("captureEvent", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        action: action
    }, data));
    (0,_gtag__WEBPACK_IMPORTED_MODULE_5__/* .event */ .B)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        action: action
    }, data));
    if (typeof (window === null || window === void 0 ? void 0 : (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.track) === "undefined") return;
    console.log("sending event to segment");
    window.analytics.track(_constants__WEBPACK_IMPORTED_MODULE_0__/* .events */ .U3[action] || action, data);
};


/***/ }),

/***/ 8016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ni": function() { return /* binding */ useLockBodyScroll; },
/* harmony export */   "_i": function() { return /* binding */ fetcher; },
/* harmony export */   "m2": function() { return /* binding */ updateUTMParams; },
/* harmony export */   "oH": function() { return /* binding */ validateEmail; },
/* harmony export */   "uD": function() { return /* binding */ getUrlWithUtms; }
/* harmony export */ });
/* unused harmony exports randomIntFromInterval, useOutsideAlerter, createDictionary, getTeamFromSlug */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useTeams__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99986);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31304);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_3__);







var fetcher = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return fetch.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(args)).then(function(res) {
        return res.json();
    });
};
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function useOutsideAlerter(ref) {
    var handleClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        return null;
    }, props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    useEffect(function() {
        var handleClickOutside = /**
     * Alert if clicked on outside of element
     */ function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                handleClick(event);
            }
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref
    ].concat(_to_consumable_array(props)));
}
function getUrlWithUtms() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", utmContentAppend = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (!url) return "";
    if (false) {}
    var params = new URLSearchParams(window.location.search);
    var keys = [
        "utm_source",
        "utm_medium",
        "utm_term",
        "utm_campaign",
        "utm_content",
        "savvy_flow_version",
        "promoCode",
        "variant", 
    ];
    keys.map(function(key) {
        var value = params.get(key);
        if (key === "utm_content" && params.get("workoutId")) {
            return url.searchParams.set(key, "web_wo_".concat(params.get("workoutId")).concat(utmContentAppend));
        }
        if (!!value) {
            url.searchParams.set(key, value);
        }
    });
    return url;
}
var updateUTMParams = function(initialURL, utmContentAppend) {
    var url;
    try {
        url = new URL(initialURL);
    } catch (_) {
        if (true) {
            url = new URL(window.location.origin + initialURL);
        }
    }
    return getUrlWithUtms(url, utmContentAppend);
};
function createDictionary(data) {
    var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "id";
    if (!(data === null || data === void 0 ? void 0 : data.length)) return {};
    var dictionary = {};
    data.map(function(n) {
        dictionary[n[key]] = n;
    });
    return dictionary;
}
function useLockBodyScroll() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // Get original body overflow
        var originalStyle = window.getComputedStyle(document.body).overflow;
        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";
        // Re-enable scrolling when component unmounts
        return function() {
            return document.body.style.overflow = originalStyle;
        };
    }, []); // Empty array ensures effect is only run on mount and unmount
}
var getTeamFromSlug = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        var isTeamID, getData, response, ref, team, ref1, team1;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    isTeamID = slug.length === 36;
                    getData = (0,_hooks_useTeams__WEBPACK_IMPORTED_MODULE_2__/* .getTeams */ .LK)();
                    _ctx.next = 4;
                    return getData();
                case 4:
                    response = _ctx.sent;
                    if (!isTeamID) {
                        _ctx.next = 8;
                        break;
                    }
                    ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(response.filter(function(param) {
                        var id = param.id;
                        return id === slug;
                    }), 1), team = ref[0];
                    return _ctx.abrupt("return", team);
                case 8:
                    ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(response.filter(function(param) {
                        var name = param.name;
                        return slugify__WEBPACK_IMPORTED_MODULE_3___default()(name, {
                            lower: true
                        }) === slug;
                    }), 1), team1 = ref1[0];
                    return _ctx.abrupt("return", team1);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTeamFromSlug(slug) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 52970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ trackTTQEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25934);



var trackTTQEvent = function(event) {
    var _content = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, idName = arguments.length > 2 ? arguments[2] : void 0;
    var ref, ref1, ref2, ref3;
    if (typeof (window === null || window === void 0 ? void 0 : (ref = window.ttq) === null || ref === void 0 ? void 0 : ref.instance) === "undefined") return;
    var eventIdName = "ttq_event_".concat(idName || event);
    var event_id = js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(eventIdName);
    if (!event_id) {
        event_id = (0,uuid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
        js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(eventIdName, event_id);
    }
    var content = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        env: "production"
    }, _content);
    console.log("trackTTQEvent", {
        event: event,
        content: content,
        eventIdName: eventIdName,
        event_id: event_id
    });
    window === null || window === void 0 ? void 0 : (ref1 = window.ttq) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.instance) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.call(ref1, "C97L7M3C77U37LFVKAFG")) === null || ref3 === void 0 ? void 0 : ref3.track(event, content, {
        event_id: event_id
    });
};


/***/ }),

/***/ 93335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ useIsDesktop; },
/* harmony export */   "Gc": function() { return /* binding */ useBreakpoint; },
/* harmony export */   "R3": function() { return /* binding */ useOrientation; },
/* harmony export */   "dD": function() { return /* binding */ useIsMobile; },
/* harmony export */   "iP": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// Hook
function useWindowSize() {
    var handleResize = function handleResize() {
        // Set window width/height to state
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        // eslint-disable-next-line no-undefined
        width: undefined,
        // eslint-disable-next-line no-undefined
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // only execute all the code below in client side
        if (true) {
            // Handler to call on window resize
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return function() {
                return window.removeEventListener("resize", handleResize);
            };
        }
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}
var useBreakpoint = function() {
    var width = useWindowSize().width;
    if (width < 640) {
        return "sm";
    } else if (width < 768) {
        return "md";
    } else if (width < 1024) {
        return "lg";
    } else {
        return "xl";
    }
};
var useOrientation = function() {
    var ref = useWindowSize(), width = ref.width, height = ref.height;
    return {
        landscape: height < width,
        portrait: height > width
    };
};
var useIsMobile = function() {
    var breakpoint = useBreakpoint();
    return [
        "sm",
        "md",
        "lg"
    ].includes(breakpoint);
};
var useIsDesktop = function() {
    var breakpoint = useBreakpoint();
    return [
        "xl"
    ].includes(breakpoint);
};


/***/ }),

/***/ 30784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ExperimentProvider; },
/* harmony export */   "a": function() { return /* binding */ useExperiment; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var unstated_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88305);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52979);




var useContainer = function() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        variant: initialState
    };
};
var ref = (0,unstated_next__WEBPACK_IMPORTED_MODULE_3__/* .createContainer */ .f)(useContainer), useExperiment = ref.useContainer, ExperimentProvider = ref.Provider;



/***/ }),

/***/ 67341:
/***/ (function(module) {

module.exports = JSON.parse('{"footer":{"cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=hero-cta&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2&page=0"},"tiktok":{"label":"Find your plan","href":"/tiktok/quiz/start"},"riddler":{"label":"Find your plan","href":"/quiz?variant=riddler_tiktok_quiz_v1"}}},"pricing":{"title":"","description":"","cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=hero-cta&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2&page=0"}}},"notice":{"nutrabolt":{"0":{"html":"You’ve Unlocked a Premium Month-Long Trial. No Credit Card Required. <b class=\'px-2 text-volt cta\'><a href=\'/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=banner&utm_content=homepagesurvey\'>FIND YOUR PLAN</a></b>"}},"home":{"0":{"html":"GET LADDER’S <b class=\'text-volt\'>FREE</b> WORKOUT OF THE DAY  → <a class=\'px-1 font-bold text-volt\' href=\'/workout/today?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=banner&utm_content=homepagesurvey\'>UNLOCK NOW</a>"},"tiktok":{"html":"Try Ladder risk-free for 7 days. <b class=\'px-2 text-volt cta\'><a href=\'/tiktok/quiz/start\'>FIND YOUR PLAN</a></b>"},"riddler":{"html":"Try Ladder risk-free for 7 days. <b class=\'px-2 text-volt cta\'><a href=\'/quiz\'>FIND YOUR PLAN</a></b>"}}},"nav":{"cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=nav&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2"},"tiktok":{"label":"Find your plan","href":"/tiktok/quiz/start"},"riddler":{"label":"Find your plan","href":"/quiz?variant=riddler_tiktok_quiz_v1"}}},"home":{"hero":{"bg":{"0":"main.png","1":"b/main.png"},"super":{"0":"For busy people who prioritize fitness"},"title":{"0":"Get stronger and workout more, without planning workouts"},"description":{"0":"Discover a workout plan for every day that’s easy to follow, can be done from anywhere, and is new each week."},"cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=hero-cta&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2&page=0"},"tiktok":{"label":"Find your plan","href":"/tiktok/quiz/start"},"riddler":{"label":"Find your plan","href":"/quiz?variant=riddler_tiktok_quiz_v1"}}},"beni":[{"title":"Results in less time","details":"Make the most of your workouts and spend no time planning.","icon":"clock"},{"title":"New workouts weekly","details":"5+ new workouts each week and a variety of training plans to choose from.","icon":"calendar"},{"title":"Always with you","details":"Stay consistent with challenging workouts that can be done from anywhere.","icon":"friends"},{"title":"Real Coaching","details":"Have confidence in your workouts and form, get answers to all your questions.","icon":"chat"}],"eachDay":{"title":{"0":"Know exactly what WORKOUT to do, eVERY day"},"description":{"0":"A workout plan for every day, created by an expert coach and new each week."},"cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=eachDay-cta&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2"},"tiktok":{"label":"Find your plan","href":"/tiktok/quiz/start"},"riddler":{"label":"Find your plan","href":"/quiz?variant=riddler_tiktok_quiz_v1"}}},"watch":{"title":{"0":"Save time and train on your schedule"},"description":{"0":"Workouts that are easy to follow, fit into your schedule, and can be done from anywhere."},"cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=saveTime-cta&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2"},"tiktok":{"label":"Find your plan","href":"/tiktok/quiz/start"},"riddler":{"label":"Find your plan","href":"/quiz?variant=riddler_tiktok_quiz_v1"}}},"training":{"title":{"0":{"html":"<span class=\'text-4xl\'>Learn from</span> <br /> the best <br /> coaches"}},"description":{"0":"Answers to all your questions, know ‘the why’ of everything you do."},"cta":{"0":{"label":"Find your plan","href":"/quiz?utm_medium=organic&utm_source=website&utm_campaign=homepage&utm_term=training-cta&utm_content=homepagesurvey&variant=riddler_hybrid_og_v2"},"tiktok":{"label":"Find your plan","href":"/tiktok/quiz/start"},"riddler":{"label":"Find your plan","href":"/quiz?variant=riddler_tiktok_quiz_v1"}}},"payment":{"title":{"0":{"html":"FREE TRIAL NOW, <br /> No credit card needed. "}},"description":{"0":"Answers to all your questions, know ‘the why’ of everything you do."},"cta":{"0":{"label":"Find your plan","link":"/pricing"}}},"shopAd":{"title":{"0":"SHOP"},"description":{"0":"Shop fitness equipment, apparel and accessories exclusively available to  Ladder members."},"cta":{"0":{"label":"Visit Shop","href":"https://shop.joinladder.com/"}}}}}');

/***/ })

}]);